import Backbone from 'backbone';

/**
 * Enum specifying the types of 'sports' that PRs are supported for.
 */
var Sports = {
    Run: 'RUN',
    Cycle: 'CYCLE',
    Steps: 'STEPS',
    Swim: 'SWIM', // only lap swimming is supported
    Training: 'TRAINING',
    Walking: 'WALKING',
    Pushes: 'WHEELCHAIR_PUSH_WALK',
    Parasports: 'WHEELCHAIR_PUSH_RUN'
};

var PersonalRecord = Backbone.Model.extend({
    initialize: function(args) {},

    urlRoot: '/personalrecord-service/personalrecord/',

    backend: 'gcapi'
});

PersonalRecord.Sports = Sports;

export default PersonalRecord;
